/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CampaignListEntryFromJSON, CampaignListEntryToJSON, MetaDataFromJSON, MetaDataToJSON, NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './';
export function CampaignWrapperResponseFromJSON(json) {
    return CampaignWrapperResponseFromJSONTyped(json, false);
}
export function CampaignWrapperResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'campaigns': !exists(json, 'campaigns') ? undefined : (json['campaigns'].map(CampaignListEntryFromJSON))
    };
}
export function CampaignWrapperResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'id': value.id,
        'name': value.name,
        'organisationId': value.organisationId,
        'userId': value.userId,
        'metaData': MetaDataToJSON(value.metaData),
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(CampaignListEntryToJSON))
    };
}
